import NoDataIcon from "assets/icons/no_data.svg"
import CMSTypography, {
  fontSizes,
  fontWeights
} from "components/common/typography/CMSTypography"
import PropTypes from "prop-types"
import React from "react"

import { DEFAULT_NO_DATA_HEADING } from "./constants"

function NoData({ header, text, className, imageClassName }) {
  return (
    <div
      className={`${className} d-flex flex-column align-items-center justify-content-center flex-fill`}
    >
      <img
        src={NoDataIcon}
        alt="no-data-icon"
        className={`${imageClassName} mb-1 no-data-img`}
      />
      <CMSTypography
        fontSize={fontSizes.small}
        fontWeight={fontWeights.semiBold}
      >
        {header}
      </CMSTypography>
      <CMSTypography fontSize={fontSizes.normal} fontWeight={fontWeights.light}>
        {text}
      </CMSTypography>
    </div>
  )
}

NoData.defaultProps = {
  header: DEFAULT_NO_DATA_HEADING,
  text: "There is no data to display at this time.",
  className: "",
  imageClassName: ""
}

NoData.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string
}

export default NoData
